export default __webpack_public_path__ + "static/bg-trapezoid-c7b97fa4d28bd8d50f96934f59f1792b.png";